import React, { useState } from "react";
import styles from "./update-contract.module.scss";
import { ContractWorks } from "../../contractWorks/contractWorks";
import { EditContract } from "../editContract/editContract";
import { useNavigate, useParams } from "react-router-dom";
import { useGetContractQuery } from "../contractApi";
import { ReactComponent as EditIcon } from "./assets/edit.svg";
import { ReactComponent as DoneIcon } from "./assets/done.svg";
import { Tooltip } from "../../../../../ui/tooltip/Tooltip";
import { IconButton } from "../../../../../ui/iconButton/IconButton";
import { Button } from "../../../../../ui/button/Button";
import { ContractAircrafts } from "../../contractAircrafts/contractAircrafts";

const UpdateContract = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isEditOpen, setIsEditOpen] = useState(false);
  const {
    data: contract,
    isFetching: isContractFetching,
    isError: isContractError,
  } = useGetContractQuery(Number(id));

  const edit = () => {
    setIsEditOpen(true);
  };

  if (!id) {
    return null;
  }
  const back = () => {
    navigate(-1);
  };
  return (
    <div className={styles.main}>
      <div className={styles.actions}>
        <Button onClick={back}>{`< Назад`}</Button>
      </div>
      <h2 className={styles.title}>Редактирование договора</h2>
      <section className={styles.contract}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>№ договора</th>
              <th>Дата начала договора</th>
              <th>Дата окончания договора</th>
              <th>Подрядчик</th>
              <th>Общая стоимость</th>
              <th>Активность</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{contract?.name}</td>
              <td>{contract?.date_start}</td>
              <td>{contract?.date_end}</td>
              <td>{contract?.contractor_name}</td>
              <td>{contract?.total_cost}</td>
              <td>{Boolean(contract?.active) && <DoneIcon />}</td>
              <td>
                <Tooltip label="Редактировать запись">
                  <IconButton onClick={edit}>
                    <EditIcon />
                  </IconButton>
                </Tooltip>
              </td>
            </tr>
          </tbody>
        </table>
        <div className={styles.subtitle}>Примечание</div>
        <p className={styles.comment}>{contract?.comment}</p>
      </section>
      <div className={styles.devider} />
      <ContractAircrafts />
      <div className={styles.devider} />
      <ContractWorks />
      {isEditOpen && (
        <EditContract close={() => setIsEditOpen(false)} id={Number(id)} />
      )}
    </div>
  );
};

export default UpdateContract;
